import { render, staticRenderFns } from "./CardUI.vue?vue&type=template&id=a5266ff6&scoped=true&"
import script from "./CardUI.vue?vue&type=script&lang=js&"
export * from "./CardUI.vue?vue&type=script&lang=js&"
import style0 from "./CardUI.vue?vue&type=style&index=0&id=a5266ff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5266ff6",
  null
  
)

export default component.exports